import axios, { AxiosInstance, AxiosResponse } from "axios";
import {
  UserDetailsList,
  RideEndList,
  RideEndResponse,
  EvilsList,
  AllFleetLocationResponse,
  DocumentDownloadResponse,
  IotDetail,
  OverviewDetail,
  NotificationList,
  FleetTypeListResponse,
  RFD
} from "../../@Types/DRO/ZyppLiteApiResponse/ApiResponse";

export class ZyppLiteApi {
  public static api = new ZyppLiteApi();
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    });
  }
  getToken() {
    return localStorage.getItem("token");
  }

  userRiderEnd(userId?: number | null): Promise<RideEndResponse> {
    let apiUrl = "/users/dashboard/complete-ride-end";

    return this.instance
      .post<RideEndResponse>(
        apiUrl,
        { userId },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      )
      .then((e) => {
        return e.data;
      });
  }

  userDeatailList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<UserDetailsList> {
    let apiUrl = "/users/dashboard/users";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<UserDetailsList>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
   rideEndedList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<RFD> {
    let apiUrl = "/users/fleet-ease/api/ride-end/vehicles/list";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<RFD>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  readyAllotmentList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<RFD> {
    let apiUrl = "/users/fleet-ease/api/rfa/vehicles/list";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<RFD>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  extendRentalPlan(payload: {
  userId: number;
  updatedExpirationTime: string;
  remarks: string;
}) {
  return this.instance.put(
    "/users/dashboard/rental/extend-plan",
    payload
  );
}

  getpaymentDetailList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<UserDetailsList> {
    let apiUrl = "/users/dashboard/transaction-history";
    if (search) {
      apiUrl += `?searchText=${search}`;
    }
    return this.instance
      .get<UserDetailsList>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  getCredentialsInfo(){
     let apiUrl = "/users/dashboard/fetch/client-credentials";
    return this.instance.get(apiUrl).then((e)=>e.data )
  }
  riderEndList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<RideEndList> {
    let apiUrl = "/users/dashboard/ride-end-requests";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<RideEndList>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  evDeatailList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<EvilsList> {
    let apiUrl = "/users/fleet-ease/api/vehicles";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<EvilsList>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  iotDisconnectedList(
    search?: string | null,
    page?: number | null,
    pageSize?: number | null
  ): Promise<EvilsList> {
    let apiUrl = "/users/dashboard/get-disconnected-vehicle";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<EvilsList>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          pageSize: pageSize,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  async getAllFleetLocation(
    search: string | null
  ): Promise<AllFleetLocationResponse> {
       let apiUrl = "/users/dashboard/get-vehicle-map-data";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    try {
      const response: AxiosResponse<AllFleetLocationResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
  async googleMapsOnDutyRiders(): Promise<AllFleetLocationResponse> {
    let apiUrl = "/users/dashboard/get-vehicle-map-data";

    try {
      const response: AxiosResponse<AllFleetLocationResponse> =
        await this.instance.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching user past tickets", error);
      throw error;
    }
  }
 updateRideEndStatus(vehicleIds: number[]): Promise<any> {
  const apiUrl = "/users/dashboard/update/ride-end-status";

  return this.instance.post(apiUrl, {
    vehicleIds,
  });
}


  downloadDocumentRc(
    vehicleId?: string | null
  ): Promise<DocumentDownloadResponse> {
    let apiUrl = "/users/dashboard/download-rc";

    return this.instance
      .get<DocumentDownloadResponse>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          vehicleId: vehicleId,
        },
      })
      .then((e) => {
        return e.data;
      });
  }

  downloadDocumentInsurance(
    vehicleId?: string | null
  ): Promise<DocumentDownloadResponse> {
    let apiUrl = "/users/dashboard/download-insurance";

    return this.instance
      .get<DocumentDownloadResponse>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          vehicleId: vehicleId,
        },
      })
      .then((e) => {
        return e.data;
      });
  }

  iotDeatailData(): Promise<IotDetail> {
    let apiUrl = "/users/dashboard/grouped-iot-details";

    return this.instance
      .get<IotDetail>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  overviewDeatailData(): Promise<OverviewDetail> {
    let apiUrl = "users/dashboard/grouped-overview-details";

    return this.instance
      .get<OverviewDetail>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  notificationList(
    search?: string | null,
    page?: number | null,
    size?: number | null
  ): Promise<NotificationList> {
    let apiUrl = "/users/notification/get";
    if (search) {
      apiUrl += `?search=${search}`;
    }
    return this.instance
      .get<NotificationList>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          page: page,
          size: size,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  fleetTypeList(): Promise<FleetTypeListResponse> {
    let apiUrl = "/users/dashboard/fleet-types";

    return this.instance
      .get<FleetTypeListResponse>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  updateVehicleIoT(payload: {
    bleMac: string;
    msisdn: string;
    iotType: number;
    vehicleId: number;
    newImei: string;
  }): Promise<any> {
    const apiUrl = "/users/dashboard/update-vehcile-iot";

    return this.instance
      .post(apiUrl, payload, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
  }

  getStatus(vehicleNo: string): Promise<FleetTypeListResponse> {
    let apiUrl = "/socket/api/v1/motor/status";

    return this.instance
      .get<FleetTypeListResponse>(apiUrl, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          vehicleNo: vehicleNo,
        },
      })
      .then((e) => {
        return e.data;
      });
  }
  verifyRentalPlan(data: { userId: number; planStatus: string;   }) {
    return this.instance
      .post("/users/dashboard/rental/plan-verify", data, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
  }
  getStatusRideEnd(data: {
    userId: number;
    vehicleNumber: string;
  }): Promise<FleetTypeListResponse> {
    const apiUrl = "/users/dashboard/ride-end-status";

    return this.instance
      .post<FleetTypeListResponse>(apiUrl, data, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      })
      .then((e) => {
        return e.data;
      });
  }

   async getWalletUserDetails(search: string) {
    const apiUrl = `/users/dashboard/wallet/user-details`;

    const response: AxiosResponse<any> = await this.instance.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
      },
      params: { search },
    });

    return response.data;
  }

  async deductWalletAmount(payload: {
    driverId: number;
    deductionAmount: number;
    reason: string;
    deductionType: string;
  }) {
    const apiUrl = `/users/dashboard/wallet/deduction`;

    const response: AxiosResponse<any> = await this.instance.put(apiUrl, payload, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  }
}
